import { Card, CardBody, FCC, Icon } from "@dgs/core";
import styled from "styled-components";

const StyledCard = styled(Card)`
	background-color: ${({ theme }) => theme.colors.palette.danger.main.base};
	color: ${({ theme }) => theme.colors.palette.danger.main.contrast};
`;

const ErrorIcon = styled(Icon)`
	height: 1.25rem;
	width: 1.25rem;
`;

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: max-content 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
	align-items: center;
`;

export const ErrorCard: FCC = ({ children }) => {
	return (
		<StyledCard $variant="outlined">
			<StyledCardBody>
				<ErrorIcon $icon="warning" />
				{children}
			</StyledCardBody>
		</StyledCard>
	);
};
